import { Component, Input, OnInit } from '@angular/core';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';

@Component({
  selector: 'app-session-booked-overview-club',
  templateUrl: './session-booked-overview-club.component.html',
  styleUrls: ['./session-booked-overview-club.component.scss']
})
export class SessionBookedOverviewClubComponent implements OnInit {
  @Input() club: ClubDetails;

  constructor(
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void { }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

}
